module.exports = __webpack_public_path__ + "static/media/bin-contrast.381ff245.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bin-contrast.svg
// module id = 657
// module chunks = 0